import { useTranslation } from 'react-i18next';
import { LANGUAGE_CODE_KEY } from '../../../utils/constants';

const SleepFooter = () => {
  const { t } = useTranslation();
  return (
    <div id="growth-footer">
      <p style={{ color: 'black' }}>{t('analytics:sleepAnalytics:footer.hours-clarification')}</p>
      {localStorage.getItem(LANGUAGE_CODE_KEY) === 'bg' ? (
        <div id="view-more">
          <p>{t('analytics:sleepAnalytics:footer.is-it-sleeping')}</p>
          <a
            target="_blank"
            href="https://www.namama.bg/category/griji-i-stimuli/rejim/"
            rel="noreferrer"
          >
            {t('analytics:shared.view-more')}
          </a>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default SleepFooter;
